import React from "react";
import { Text } from "./SkeletonMarketplaceSortLoader.styles";

const SkeletonMarketplaceSortLoader = ({ single, marketplace }) => {
  const data = [
    { id: 1, text: "Candles" },
    { id: 2, text: "Language Day" },
    { id: 3, text: "Winter Collection" },
    { id: 5, text: "Language Day" },
    { id: 6, text: "Candles" },
    { id: 7, text: "Winter Collection" },
    { id: 8, text: "Language Day" },
    { id: 9, text: "Candles" },
  ];

  return single ? (
    <Text />
  ) : (
    data.map((x) => (
      <Text key={x.id} $marketplace={marketplace}>
        {marketplace && `${x.text}`}
      </Text>
    ))
  );
};

export default SkeletonMarketplaceSortLoader;
